import {
  loadLatestUpdatesSuccess,
  loadLatestUpdatesError,
  loadManageAccessUsersSuccess,
  loadManageAccessUsersError,
  loadManageAccessUserDetail,
  loadManageAccessUserDetailSuccess,
  loadManageAccessUserDetailError,
  resetManageAccessTile,
  fetchMessages,
  fetchMessagesSuccess,
  fetchMessagesError,
} from './dashboard.actions';
import { on, createReducer, Action } from '@ngrx/store';

import { LatestUpdate } from '../latest-updates/latest-updates.model';
import { ServiceError, Message } from '@cigna/chcp/shared/util';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { User } from '@cigna/chcp/working-with-cigna/manage-access-feature';
import { LOADING_STATE } from '../dashboard.constants';

export const DASHBOARD_FEATURE_KEY = 'dashboard';

export interface DashboardState {
  latestUpdates: LatestUpdate[];
  latestUpdatesLoading: boolean;
  manageAccessUsers: User[];
  manageAccessUsersLoading: boolean;
  manageAccessViewingUser: User | null;
  manageAccessViewingUserView: LOADING_STATE;
  messages: Message[];
  isMessagesLoading: boolean;
  messagesError?: ServiceError;
}

export interface DashboardPartialState {
  readonly [DASHBOARD_FEATURE_KEY]: DashboardState;
}

export const initialState: DashboardState = {
  latestUpdates: [],
  latestUpdatesLoading: true,
  manageAccessUsers: [],
  manageAccessUsersLoading: true,
  manageAccessViewingUser: null,
  manageAccessViewingUserView: LOADING_STATE.loading,
  messages: [],
  isMessagesLoading: false,
  messagesError: undefined,
};

export const dashboardReducer = createReducer(
  initialState,
  on(resetManageAccessTile, (state) => ({
    ...state,
    manageAccessUsers: [],
    manageAccessUsersLoading: true,
    manageAccessViewingUser: null,
  })),
  on(loadManageAccessUsersSuccess, (state, { users }) => ({
    ...state,
    manageAccessUsers: users,
    manageAccessUsersLoading: false,
  })),
  on(loadManageAccessUsersError, (state) => ({
    ...state,
    manageAccessUsersLoading: false,
  })),
  on(loadLatestUpdatesSuccess, (state, { updates }) => ({
    ...state,
    latestUpdates: updates,
    latestUpdatesLoading: false,
  })),
  on(loadLatestUpdatesError, (state) => ({
    ...state,
    latestUpdatesLoading: false,
  })),
  on(loadManageAccessUserDetail, (state) => ({
    ...state,
    manageAccessViewingUserView: LOADING_STATE.loading,
    manageAccessViewingUser: null,
  })),
  on(loadManageAccessUserDetailSuccess, (state, { user }) => ({
    ...state,
    manageAccessViewingUser: user,
    manageAccessViewingUserView: LOADING_STATE.loaded,
  })),
  on(loadManageAccessUserDetailError, (state) => ({
    ...state,
    manageAccessViewingUserView: LOADING_STATE.error,
  })),
  on(fetchMessages, (state) => ({
    ...state,
    isMessagesLoading: true,
    messagesError: undefined,
  })),
  on(fetchMessagesSuccess, (state, { messages }) => ({
    ...state,
    isMessagesLoading: false,
    messages,
  })),
  on(fetchMessagesError, (state, { error }) => ({
    ...state,
    isMessagesLoading: false,
    messagesError: error,
  })),
);

export function reducer(state: DashboardState | undefined, action: Action) {
  return dashboardReducer(state, action);
}
